import Base from '@studiometa/js-toolkit';
import { isDev } from '../config';

/**
 * SearchFooter class
 */
export default class SearchFooter extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'SearchFooter',
      log: isDev(),
    };
  }

  /**
   * On Click
   */
  onClick() {
    const [header] = this.$parent.$children.Header;

    if (!header) {
      return;
    }

    const [search] = header.$children.Search;
    const [mobileSearch] = header.$children.MobileSearch;

    header.show();

    if (search) {
      search.open();
    }

    if (mobileSearch) {
      mobileSearch.open();
    }
  }
}
